<div class="header-text">
    <img *ngIf="item.showInUnified" src="../../../assets/img/eye-open.png" alt="of" class="eye-style"
        (click)="changeShowing()">
    <img *ngIf="!item.showInUnified" src="../../../assets/img/eye-closed.png" alt="of" class="eye-style"
        (click)="changeShowing()">
    {{header}}
</div>

<div class="text">
    {{currentText}}
</div>

<div class="text-center mt-5" *ngIf="texts.length > 1">
    <button
        class="bg-paginator-btn text-white w-26 text-sm font-bold uppercase paginator-btn rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="submit" (click)="goBack()">
        < </button>

            {{currentIdx + 1}} de {{texts.length}}

            <button
                class="bg-paginator-btn text-white w-26 text-sm font-bold uppercase paginator-btn rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="submit" (click)="goAhead()">
                >
            </button>
</div>
